/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Ranked_No_Proxies_HintInputs */



/**
* | output |
* | --- |
* | "Not allowed in National or Continental championships." |
*
* @param {Tfield_Ranked_No_Proxies_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_ranked_no_proxies_hint = /** @type {((inputs?: Tfield_Ranked_No_Proxies_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Ranked_No_Proxies_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non autorisé dans le championnat national ou continental.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No permitido en el Campeonato Nacional o Continental.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não permitido em torneios National Championship ou Continental Championship.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non consentito nel Campionato Nazionale o Continentale.")
	return /** @type {LocalizedString} */ ("Not allowed in National or Continental championships.")
});